<template>
  <layout-page :nav-bar-show-logo-text="false">
    <page-breadcrumb :hierarchy="breadCrumbs"/>
    <div class="container">
      <h1 class="font-large text-blue-60 text-2xl text-center py-4 lg:text-left lg:text-3xl">
        <span class="font-extrabold">About Us</span>
      </h1>
      <h3 class="font-large text-blue-60 text-2xl text-center py-4 lg:text-left lg:text-3xl">
        <span class="font-extrabold">
          Like so many online services, Agency Central was born in the back rooms of its founding members. Brothers Kevin and Phil Drinkwater spent many a sleepless night working on the original site back in 2000 - before quitting their day jobs to manage the site full time in 2002.
        </span>
      </h3>

      <div>
        <p class="text-lg text-grey-70 font-bold">
          At Agency Central, we live to help recruitment agencies do their job - because they are a great way for businesses to find the right employees and for people to find their perfect job, whether that be permanent, temporary, or a headhunted position they don't even know about yet! We've designed our website specifically to be the easiest possible way of connecting these two parties - which is underlined by the fact that it's now used by around 400 employers and 5000 candidates every single day.
        </p>
      </div>
      <div>
        <blockquote class="blockquote">
          <p>Since our humble beginnings, we've had contact made by over 500,000 employers looking to fill vacancies and almost eleven million candidates looking for jobs. That's a lot of happy customers and the number's climbing! To service that demand, we've welcomed more staff on board (there's now about 15 of us working here behind the scenes), and consequently we keep having to move to larger premises!</p>
        </blockquote>
      </div>

      <div>
        <p class="text-lg text-grey-70 font-bold">
          With this growth in mind, we are busy streamlining our service to ensure that more people than ever before are finding what they need through our site. You've probably noticed some big changes around here recently, and there are even more to come. Coupled with the strong relationships we build with candidates through social media, this means that we are fast-becoming one of the UK's go-to destinations when people are looking for recruitment knowledge and services.
        </p>
      </div>

      <div class="pt-5 text-grey-70">
        <div class="pb-4">
          <span class="font-extrabold">Kevin Drinkwater</span>
          <span><i>Managing Director</i></span>
        </div>
        <p class="pb-3">
          It was back in the 1990s when I had the idea for a website that would make it easier to find recruitment agencies. At the time, I was working as a manager for one of the largest IT services companies in the UK, and I used to deal with a number of agencies in order to find commercial and technical staff - which meant that I already knew a fair bit about the recruitment industry.
        </p>
        <p class="pb-3">
          When I decided to start looking for a new challenge in 1999, I knew that I wanted to contact some specialist sales and management recruitment agencies, but quickly found that there was no easy way to find agencies who specialised in particular industries and job roles. That's where the idea for Agency Central came from. Since launching the company in 2000, we've made some bad decisions along the way just like any business, but what has kept us going is our desire to be the best possible resource to help candidates and employers find the most suitable recruitment agencies to work with.
        </p>
        <p class="pb-3">
          In my personal life, I like to spend time with my family and friends, dining out, and touring around Europe. Sports-wise, I'm quite heavily involved in running one of the largest junior football leagues in the UK, and I'm a big fan of Manchester United FC.
        </p>
      </div>

      <div class="pt-5 text-grey-70">
        <div class="pb-4">
          <span class="font-extrabold">Phil Drinkwater</span>
          <span><i>Technical Director</i></span>
        </div>
        <p class="pb-3">
          I've also got a background in Computer Science, and in a former life I programmed computer games - before moving into project management. I was the sole developer of the original Agency Central website, although nowadays I work alongside many others overseeing the content and marketing direction that we take online.
        </p>
        <p class="pb-3">
          When I'm not in the office, I'm a keen photographer and cyclist - having recently completed the Coast to Coast Challenge in aid of Sound Sense. I also enjoy learning about physics, and have an interest in astronomy.
        </p>
      </div>

    </div>
  </layout-page>
</template>

<script>
import LayoutPage from "Components/layouts/LayoutPage";
import NavBar from "Components/NavBar/NavBar";
import PageBreadcrumb from 'Components/PageBreadcrumb';

export default {
  name: "About",
  components: {
      PageBreadcrumb,
    LayoutPage,
    NavBar,
  },
  computed: {
    breadCrumbs : function(){
      return [
        {
          name: 'About Us'
        }
      ]
    }
  }
};
</script>
